module.exports = __webpack_public_path__ + "img/sendStatus.10a0c1d1.png";